<script lang="ts" context="module">
  export enum ImageGalleryEvent {
    LOAD_IMAGES = 'load-images'
  }
  import {writable} from 'svelte/store';
  import {httpClient} from '../../../../utils/http-client';
  import {AssetService} from '../../../../services';
  import {onMount} from 'svelte';
  export interface IUserImageGalleryStore {
    loading: boolean;
    items: any[];
    page: number;
    hasMore: boolean;
  }
  export const userImageGalleryStore = writable<IUserImageGalleryStore>({
    loading: false,
    items: [],
    page: 1,
    hasMore: false
  });
</script>

<script lang="ts">
  import {stringify} from 'uuid';
  import Loading from '../../../icon/icons/Loading.svelte';
  import {createImageElement} from '../../../../lib/editor/helpers';
  import editorInstance from '../../../../lib/editor/editor';
  import GalleryItem from './GalleryItem.svelte';
  import {assetStore} from '../../../../services/asset/asset.store';

  $: hasItems = $userImageGalleryStore.items.length > 0;
  $: isLoading = $userImageGalleryStore.loading;
  const assetService = new AssetService();

  export function loadUserImageGallery() {
    userImageGalleryStore.update(store => ({
      ...store,
      loading: true
    }));
    assetService.loadImages($userImageGalleryStore.page).then(resp => {
      console.log('User images', resp.data);
      userImageGalleryStore.update(store => ({
        ...store,
        loading: false,
        items: resp.data?.data || [],
        hasMore: resp.data?.pagination?.hasMore || false
      }));
    });
  }
  function nextPage() {
    userImageGalleryStore.update(store => ({
      ...store,
      page: store.page + 1
    }));
    loadUserImageGallery();
  }

  function prevPage() {
    if ($userImageGalleryStore.page <= 1) return;
    userImageGalleryStore.update(store => ({
      ...store,
      page: store.page - 1
    }));
    loadUserImageGallery();
  }

  function addImage(image: any) {
    const imageEl = createImageElement(image.file.publicUrl);
    editorInstance.addComponent(imageEl, true);
  }

  function deleteImage(image: any) {
    userImageGalleryStore.update(store => {
      console.log('items', store);
      const items = store.items.filter(item => item.id !== image.id);
      return {
        ...store,
        items
      };
    });
    assetService.deleteAsset(image.id).then(resp => {
      console.log('Image deleted', resp);
      loadUserImageGallery();
    });
  }

  onMount(() => {
    userImageGalleryStore.update(store => ({
      ...store,
      page: 1
    }));
    loadUserImageGallery();
    window.addEventListener(ImageGalleryEvent.LOAD_IMAGES, loadUserImageGallery);
  });
</script>

<div class="flex w-full flex-grow flex-col items-center">
  {#if isLoading}
    <div class="block">
      <i class="fa fa-spinner fa-spin text-6xl text-slate-300"></i>
    </div>
  {/if}
  {#if !hasItems && !isLoading}
    <div class="flex h-full w-full flex-col items-center justify-center py-10 text-slate-300">
      <i class="fa fa-glass-empty block h-16 pb-4 text-6xl"></i>
      <span class="block pt-2 font-extrabold">You dont have any saved images</span>
    </div>
  {:else}
    <div class="grid w-full grid-cols-2 gap-2">
      {#each $userImageGalleryStore.items as item (item.id)}
        <GalleryItem {item} addImage={() => addImage(item)} deleteImage={() => deleteImage(item)} />
      {/each}
    </div>
    <div class="flex w-full space-x-1 py-6 text-gray-900">
      <button
        class="navbtn"
        type="button"
        role="navigation"
        on:click={() => prevPage()}
        disabled={$userImageGalleryStore.page === 1}
      >
        <span class="gg-arrow-left" /> Previous
      </button>
      <button
        class="navbtn"
        type="button"
        role="navigation"
        on:click={() => nextPage()}
        disabled={!$userImageGalleryStore.hasMore}
      >
        Next <span class="gg-arrow-right" />
      </button>
    </div>
  {/if}
</div>

<style lang="postcss">
  .navbtn {
    @apply flex w-1/2 cursor-pointer items-center justify-center rounded-lg border border-gray-200 bg-white p-2 text-center shadow-sm hover:bg-gray-300;
  }

  .navbtn:disabled {
    @apply cursor-not-allowed bg-gray-200 opacity-80 hover:bg-gray-200;
  }

  .navbtn > span {
    display: inline-flex;
    --ggs: 0.5;
  }
</style>
